/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const links = () => {
  if(window.location.hash){
    document.querySelector(window.location.hash).scrollIntoView({
      behavior: 'smooth'
    });
  }

  document.querySelectorAll('a').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      let current = window.location.href.split("#")[0];
      console.log(current == window.location.origin + '/', anchor.href.includes('#'));
      if (current == window.location.origin + '/' && anchor.hash) {
        let section = document.querySelector(anchor.hash);
        window.scroll({ top: section.offsetTop, behavior: 'smooth' })
      } else {
        window.location = anchor.href;
      }
    });
  });
};

export default links;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/factory-logistic-chisel/src/scripts/modules/links.js